<template>
  <v-card
    class="mt-4 pa-4"
    border
  >
    <h4 class="mb-1 text-subtitle-2">
      {{ $t('labels.commentary') }}
    </h4>
    <v-textarea
      v-model="text"
      rows="4"
      hide-details
      variant="outlined"
      density="compact"
      :disabled="isMasterView"
    />

    <div class="justify-end mt-3 d-flex">
      <v-btn
        color="primary"
        size="small"
        :disabled="text === '' || isMasterView"
        @click="submit"
      >
        {{ $t('labels.add') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import bus, { eventNames } from '@/lib/eventBus'

import ADD_COMMENTARY from './queries/AddCommentary.gql'
import LEAD from './queries/Lead.gql'

export default {
  props: {
    leadId: {
      type: String,
      default: null,
    },
    isMasterView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    async submit() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: ADD_COMMENTARY,
          variables: {
            leadId: this.leadId,
            text: this.text,
          },
          refetchQueries: [{ query: LEAD, variables: { id: this.leadId } }],
        })

        if (data.response) this.text = ''

        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'success',
          text: this.$t('alerts.lead.commentary.success'),
        })
        this.$tracking.event('Lead', 'Clicked', 'Commentary')
      } catch (e) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.lead.commentary.error'),
        })
      }
    },
  },
}
</script>
